var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-transporte"},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg12":"","sm12":"","xs12":""}},[_c('Transportadora')],1),_c('v-flex',{attrs:{"lg3":"","sm3":""}},[_c('Menu')],1),_c('v-flex',{attrs:{"lg9":"","sm9":""}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }